<canvas #canvas width="{{canvasWidth}}" height="{{canvasHeight}}" ></canvas>
